import { sellerConstants } from '../../../_constants/seller.constants';
import { sellerAdminService } from '../../../_services';

export const sellerAdminActions = {
    getSellerAdmins
};

function getSellerAdmins(id) {
    return dispatch => {
        dispatch(request());

        sellerAdminService.getSellerAdmin(id)
            .then(
                sellerAdmins => {
                    dispatch(success(sellerAdmins));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_SELLER_ADMIN } }
    function success(sellerAdmins) { return { type: sellerConstants.RECEIVE_SELLER_ADMIN, sellerAdmins } }
    function failure(error) { return { type: sellerConstants.SELLER_ADMIN_LIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerAdmin/sellerAdmin.actions.js